import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import { FiArrowLeft } from "react-icons/fi";
import CompanySidebar from "../../components/Dashboard/leads-dashboard/CompanySidebar";
import CompanyTabs from "../../components/Dashboard/leads-dashboard/CompanyTabs";
import AddDealModal from "../../components/modals/lead-dashboard/AddnewModals/AddDealModal";


export default function CompanyDetails() {
       const [showDealModal, setShowDealModal] = useState(false);
  return (
    <div className="page-wrapper p-4">
      {/* HEADER */}
      <Row className="align-items-center mb-3">
        <Col md={6}>
          <h6 className="fw-medium d-flex align-items-center">
            <Link to="/companies" className="me-2 text-dark text-decoration-none">
              <FiArrowLeft /> Companies
            </Link>
            <span className="text-muted ms-2">/ BrightWave Innovations</span>
          </h6>
        </Col>

        <Col md={6} className="text-md-end mt-2 mt-md-0">
          <Button   onClick={() => setShowDealModal(true)}  className="me-2 ps-4 pe-4 pt-2 pb-2 btn-orange">Add Deal</Button>
          <Button className="ps-4 pe-4 pt-2 pb-2" variant="dark">Send Email</Button>
        </Col>
      </Row>

      {/* BODY */}
      <Row>
        <Col xl={4} className="mb-3">
          <CompanySidebar />
        </Col>

        <Col xl={8}>
          <CompanyTabs />
        </Col>
            <AddDealModal
        show={showDealModal}
        setShow={setShowDealModal}
      />
      </Row>
      <style>

        {`.btn-orange {
  background: #f26522;
  border: none;
  color: #fff;
}
  .page-wrapper{
      background-color: #f8f9fa;
  }

.btn-orange-outline {
  border: 1px solid #f26522;
  color: #f26522;
  background: white;
}

.custom-tabs .nav-link.active {
  color: #f26522 !important;
  border-bottom: 2px solid #f26522 !important;
}

.company-header {
   background: #fafafa;
  color: white;
}

.company-logo {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: white;
  padding: 10px;
}

.activity-box {
  border: 1px solid #eee;
  padding: 12px;
  border-radius: 6px;
}

.company-card {
  border-radius: 10px;
}

/* Responsive */
@media (max-width: 1024px) {
  .company-card {
    margin-bottom: 20px;
  }
}`}
      </style>
    </div>
  );
}
